import { render, staticRenderFns } from "./GuestsReport.vue?vue&type=template&id=666aff0d&scoped=true"
import script from "./GuestsReport.vue?vue&type=script&lang=js"
export * from "./GuestsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666aff0d",
  null
  
)

export default component.exports